/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyTax = {
  properties: {
    name: {
      type: 'string',
      isRequired: true,
    },
    description: {
      type: 'string',
      isRequired: true,
    },
    percentage: {
      type: 'number',
      isRequired: true,
    },
  },
} as const;
